import React from 'react'

const Manual_admin_comandas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Comandas
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        La guía explica cómo configurar impresoras de comandas, incluyendo su creación, asignación de categorías y personalización. Su uso optimiza el procesamiento de pedidos y mejora la eficiencia operativa del establecimiento.
      </p>
      <iframe
        src="https://scribehow.com/embed/Admin__Comandas__69oRb9eITP-0s7dnPfnB0Q?as=scrollable"
        className="scribe-iframe-general-171"
        width="100%"
        height="4600"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_admin_comandas